import { Form, Button } from 'react-bootstrap';
import { useForm } from 'react-hook-form';

import { HyperDatepicker } from '@components';
import { DateHelper } from '@utils/DateHelper';

type FormValues = {
  date: Date;
};

type Props = {
  date: string;
  onSearch?: (data: { date: string }) => void;
};

export function SearchBar({ date, onSearch }: Props) {
  const methods = useForm<FormValues>({
    defaultValues: {
      date: new Date(date)
    }
  });
  const { handleSubmit, control } = methods;

  const onSubmit = (data: FormValues) => {
    if (onSearch) {
      onSearch({
        date: new DateHelper(data.date).format('YYYY-MM-DD')
      });
    }
  };

  return (
    <Form className="d-flex align-items-end" onSubmit={handleSubmit(onSubmit)}>
      <Form.Group style={{ width: 150 }}>
        <Form.Label>Date</Form.Label>
        <HyperDatepicker name="date" control={control} inputClass="form-control" />
      </Form.Group>
      <div className="ms-2">
        <Button type="submit">Submit</Button>
      </div>
    </Form>
  );
}
